module.exports = __webpack_public_path__ + "img/bg_r.e8543b44.png";